module.exports = __webpack_public_path__ + "img/filter-results-button - ash.1c60cd01.svg";